import { memo, useMemo } from "react";
import UserAvatar from "../../components/UserAvatar/UserAvatar";
import { useTicketingContext } from "../../store";
import {
  CarlsbergLogo,
  InfoParagraph,
  Stepper,
  Summary,
} from "../../components";
import { FLOW_TYPES } from "../../constants/flowType";

const LOGO_COLOR = "#284a41";
const LOGO_WIDTH = "90px";

const AppLayout = ({ children }) => {
  const {
    state: { is_city_card, is_gift_card, stepper, flowType },
  } = useTicketingContext();

  const { hideOnFirstPage, hideLoginButton, hideInfoParagraph } = useMemo(() => {
    const isFirstStep = stepper?.active === 0;
    return {
      hideOnFirstPage: is_city_card && isFirstStep,
      hideLoginButton: is_city_card,
      hideInfoParagraph: is_gift_card,
    };
  }, [is_city_card, is_gift_card, stepper?.active]);

    const isGiftCardFlow = flowType === FLOW_TYPES.GIFT_CARD;
  
  return (
    <>
      <div className="app-frame" />
      <Summary />
      <div className="app-layout">
        <div className="app-layout-content">
          <CarlsbergLogo color={LOGO_COLOR} width={LOGO_WIDTH} />
          {!hideLoginButton && (
            <UserAvatar className="app-layout-content-avatar" />
          )}
          {!hideOnFirstPage && !isGiftCardFlow && <Stepper />}
          {!hideOnFirstPage && !hideInfoParagraph && <InfoParagraph />}
          {children}
        </div>
      </div>
    </>
  );
};

AppLayout.displayName = "AppLayout";
export default memo(AppLayout);
